import { render, staticRenderFns } from "./Passi.vue?vue&type=template&id=bb31a054&"
import script from "./Passi.vue?vue&type=script&lang=js&"
export * from "./Passi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports